export type TrendMetricKey =
  | 'ongoing'
  | 'closed'
  | 'quoted'
  | 'quotedWeighted'
  | 'invoicing'
  | 'targets'

export type TrendMetric = {
  key: TrendMetricKey
  label: string
  color: string
}

export type ReportMonth = {
  key: string
  label: string
  metrics: Record<TrendMetricKey, number>
}

export const TREND_METRICS: TrendMetric[] = [
  { key: 'ongoing', label: 'Ongoing total', color: '#0F766E' },
  { key: 'closed', label: 'Closed total', color: '#2563EB' },
  { key: 'quoted', label: 'Quoted total', color: '#D97706' },
  {
    key: 'quotedWeighted',
    label: 'Quoted total × likelihood (%)',
    color: '#7C3AED',
  },
  { key: 'invoicing', label: 'Actual invoicing', color: '#059669' },
  { key: 'targets', label: 'Targets', color: '#475569' },
]

export type DepartmentBreakdownKey = 'status' | 'source' | 'sector'

export type DepartmentAnalysisDepartment = {
  id: string
  name: string
}

export type DepartmentAnalysisJob = {
  id: string
  ref: string
  name: string
  departments: string[]
  status: 'quote' | 'pcc_in_progress' | 'ongoing' | 'closed' | 'lost'
  value: number
}

export type DepartmentAnalysisClassification = {
  source: string
  sector: string
}

export type DepartmentBreakdownSegment = {
  label: string
  count: number
  value: number
  color: string
}

export type DepartmentBreakdownRow = {
  id: string
  name: string
  count: number
  value: number
  segments: DepartmentBreakdownSegment[]
}
